<div class="conn-grid-main create-product">
    <div>
        <a
            *ngIf="cameFromBusinessSetup"
            class="back-to-business-setup-link"
            (click)="goBackToBusinessSetup()"
        >
            <i class="pi pi-arrow-left"></i>
            Back to Business Setup
        </a>
        <div class="settings-tabs-skeleton" *ngIf="isTabsLoading">
            <p-skeleton
                *ngFor="let width of tabSkeletonWidths"
                [width]="width"
                height="2.2rem"
                styleClass="business-tab-skeleton"
            ></p-skeleton>
        </div>

        <p-tabMenu *ngIf="!isTabsLoading" #tab [model]="items" [activeItem]="activeItem" [scrollable]="true" (click)="onTabItemClick(tab)" (keydown.enter)="onTabItemClick(tab)">
        </p-tabMenu>

        <div *ngIf="!isTabsLoading && activeItem.label === 'General'" class="fadeinright animation-duration-200 mt-3">
            <div class="conn-card">
                <h2 class="w-title card-title">General</h2>
                <div class="conn-grid general-setting-component-container">
                    <app-general [singupBusinessConfig]="false"></app-general>
                </div>
            </div>
        </div>

        <div *ngIf="!isTabsLoading && activeItem.id === 'tax-rate'" class="fadeinright animation-duration-200 mt-3">
            <div class="conn-card">
                <h2 class="w-title card-title">Tax Rate</h2>
                <div class="conn-grid general-setting-component-container">
                    <app-tax-setting [singupBusinessConfig]="false"></app-tax-setting>
                </div>
            </div>
        </div>

        <div *ngIf="!isTabsLoading && activeItem.id === 'tax-rate-v2'" class="fadeinright animation-duration-200 mt-3">
            <app-tax-setting-v2></app-tax-setting-v2>
        </div>

        <div *ngIf="!isTabsLoading && activeItem.label === 'Tender Configuration'" class="fadeinright animation-duration-200 mt-3">
            <div class="conn-card">
                <h2 class="w-title card-title">Tender Configuration</h2>
                <div class="conn-grid general-setting-component-container">
                    <app-tender-configuration [singupBusinessConfig]="false"></app-tender-configuration>
                </div>
            </div>
        </div>

        <div *ngIf="!isTabsLoading && activeItem.label === 'Shipping Configuration'" class="fadeinright animation-duration-200 mt-3">
            <div class="conn-card">
                <h2 class="w-title card-title">Shipping Configuration</h2>
                <div class="conn-grid general-setting-component-container">
                    <app-shipping-configuration [singupBusinessConfig]="false"></app-shipping-configuration>
                </div>
            </div>
        </div>

        <div *ngIf="!isTabsLoading && activeItem.label === 'Shipping Configuration (V2)'" class="fadeinright animation-duration-200 mt-3">
            <div class="conn-card">
                <h2 class="w-title card-title">Shipping Configuration (V2)</h2>
                <div class="conn-grid general-setting-component-container">
                    <app-shipping-configuration-v2 [singupBusinessConfig]="false"></app-shipping-configuration-v2>
                </div>
            </div>
        </div>

        <div *ngIf="!isTabsLoading && activeItem.label === 'Payment Processing'" class="fadeinright animation-duration-200 mt-3">
            <div class="conn-card">
                <h2 class="w-title card-title">Payment Processing</h2>
                <div class="conn-grid general-setting-component-container">
                    <app-payment-processing [singupBusinessConfig]="false"></app-payment-processing>
                </div>
            </div>
        </div>

        <div *ngIf="!isTabsLoading && activeItem.label === 'Purchase Order'" class="fadeinright animation-duration-200 mt-3">
            <div class="conn-card">
                <h2 class="w-title card-title">Purchase Order</h2>
                <div class="conn-grid general-setting-component-container">
                    <app-purchase-order [singupBusinessConfig]="false"></app-purchase-order>
                </div>
            </div>
        </div>

    </div>
</div>
